import Icon from "@ant-design/icons";
import React from "react";

export default function RefreshIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3999 6.65049C12.9495 6.55166 12.4811 6.49952 12 6.49952C8.41012 6.49952 5.49998 9.40966 5.49998 12.9995C5.49998 16.5894 8.41011 19.4995 12 19.4995C15.5898 19.4995 18.4999 16.5893 18.4999 12.9995C18.4999 12.5853 18.8357 12.2495 19.2499 12.2495C19.6642 12.2495 19.9999 12.5853 19.9999 12.9995C19.9999 17.4178 16.4182 20.9995 12 20.9995C7.58168 20.9995 3.99998 17.4178 3.99998 12.9995C3.99998 8.58123 7.58169 4.99952 12 4.99952C12.4413 4.99952 12.8747 5.03532 13.2971 5.10425L11.47 3.27713C11.1771 2.98423 11.1771 2.50936 11.47 2.21647C11.7629 1.92357 12.2378 1.92357 12.5307 2.21647L15.0055 4.69134C15.689 5.37478 15.6889 6.48281 15.0055 7.16621L12.5307 9.64109C12.2378 9.93398 11.7629 9.93398 11.47 9.64109C11.1771 9.3482 11.1771 8.87332 11.47 8.58043L13.3999 6.65049Z"
        fill="currentColor"
      />
    </svg>
  );
};
